import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import { isAdminUser, isVenueOwnerUser } from '../utils/roles';

const OwnerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const { isMobile } = useResponsive();

  // Loading state
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#181A1B',
        color: 'var(--text-primary)',
        marginLeft: isMobile ? 0 : '110px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px' }}>⚽</div>
          <div>Cargando...</div>
        </div>
      </div>
    );
  }

  // Si no hay usuario, redirigir a la página principal (landing/login)
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Check if user has owner permissions
  const isOwner = isVenueOwnerUser(user);
  const isAdmin = isAdminUser(user);

  if (!isOwner && !isAdmin) {
    // User is authenticated but not an owner - redirect to home
    return <Navigate to="/home" replace />;
  }

  // User is authenticated and has owner permissions
  return <>{children}</>;
};

export default OwnerRoute;
